module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = resourceData.data || {}\nconst attributes = data.attributes || {}\nconst {\nstatus,\nstatusOutDated,\namIAssigned,\nisOneAssigned,\nlastCoreUpdateAt,\n} = attributes\nconst additionalClasses = []\nlet statusExplanationType = ''\nconst m = utils.moment(lastCoreUpdateAt)\nconst lastCoreUpdate = {\ndate: m.format('DD.MM.YYYY'),\ntime: m.format('HH:mm')\n}\nlet symbol = ''\nlet treatStatusOutDated = false\nif(status){\nstatusExplanationType = 'valid'\nsymbol = `fi fi-${status}`\nif(status === 'revoked'){\nadditionalClasses.push('negative')\n} else {\nadditionalClasses.push('positive')\n}\nif(\nstatusOutDated ||\n(\namIAssigned &&\nstatus !== 'agreed' &&\nstatus !== 'revoked'\n) ||\n(\n!amIAssigned &&\nisOneAssigned &&\nstatus !== 'waitlisted' &&\nstatus !== 'revoked'\n)\n){\nadditionalClasses.push('statusOutDated')\nstatusExplanationType = 'statusOutDated'\n}\n} else {\nadditionalClasses.push('new')\n}\n%><div class=\"<%= additionalClasses.join(' ') %>\"><%\n%><i class=\"<%= symbol || 'fi fi-circle-question' %>\"></i><%\n%><div class=\"text\"><%\n%><div class=\"status\"><%= storage.__(`projects.advertisements.status.${status || 'none'}`) %></div><%\nif(statusExplanationType){\n%><div class=\"explanation\"><%= storage.__(`projects.advertisements.status.explanation.${statusExplanationType}`, { ...lastCoreUpdate }) %></div><%\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/crew/advertisements/detailStatusField.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = resourceData.data || {}
const attributes = data.attributes || {}
const {
status,
statusOutDated,
amIAssigned,
isOneAssigned,
lastCoreUpdateAt,
} = attributes
const additionalClasses = []
let statusExplanationType = ''
const m = utils.moment(lastCoreUpdateAt)
const lastCoreUpdate = {
date: m.format('DD.MM.YYYY'),
time: m.format('HH:mm')
}
let symbol = ''
let treatStatusOutDated = false
if(status){
statusExplanationType = 'valid'
symbol = `fi fi-${status}`
if(status === 'revoked'){
additionalClasses.push('negative')
} else {
additionalClasses.push('positive')
}
if(
statusOutDated ||
(
amIAssigned &&
status !== 'agreed' &&
status !== 'revoked'
) ||
(
!amIAssigned &&
isOneAssigned &&
status !== 'waitlisted' &&
status !== 'revoked'
)
){
additionalClasses.push('statusOutDated')
statusExplanationType = 'statusOutDated'
}
} else {
additionalClasses.push('new')
}

    ; __line = 48
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 

    ; __line = 49
    ; __append("<i class=\"")
    ; __append(escapeFn( symbol || 'fi fi-circle-question' ))
    ; __append("\"></i>")
    ; 

    ; __line = 50
    ; __append("<div class=\"text\">")
    ; 

    ; __line = 51
    ; __append("<div class=\"status\">")
    ; __append(escapeFn( storage.__(`projects.advertisements.status.${status || 'none'}`) ))
    ; __append("</div>")
    ; 
if(statusExplanationType){

    ; __line = 53
    ; __append("<div class=\"explanation\">")
    ; __append(escapeFn( storage.__(`projects.advertisements.status.explanation.${statusExplanationType}`, { ...lastCoreUpdate }) ))
    ; __append("</div>")
    ; 
}

    ; __line = 55
    ; __append("</div>")
    ; 

    ; __line = 56
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/advertisements/detailStatusField.ejs

}